import { z } from 'zod/v4';

export const AI_CALL_OUTCOMES = [
  'dispute',
  'informational',
  'bad_context_info',
  'payment_plan',
  'promise_to_pay',
  'follow_up_task',
] as const;

export type AiCallOutcome = (typeof AI_CALL_OUTCOMES)[number];

export const AiCallOutcomeSchema = z.enum([...AI_CALL_OUTCOMES]);
